import { render, staticRenderFns } from "./SelectColours.vue?vue&type=template&id=6d150dd1&"
import script from "./SelectColours.vue?vue&type=script&lang=js&"
export * from "./SelectColours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports